import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreService } from "../firebase/firestoreService";
import { FirestoreDocumentReference } from "../firebase/references";
import type { HealthCareFacilityModel } from "../types";
import type { AuthAppDispatch } from "./store";

export interface SingleHealthFacilitySliceModel {
  data?: HealthCareFacilityModel;
  loading: boolean;
  error: string | null;
}

const initialState: SingleHealthFacilitySliceModel = {
  data: undefined,
  loading: false,
  error: null,
};

const singleHealthFacilityDetailsSlice = createSlice({
  name: "singleHealthFacilityDetails",
  initialState,
  reducers: {
    fetchingSingleHealthFacilityDetails: (state) => {
      state.loading = true;
      state.error = null;
      state.data = undefined;
    },
    setHealthFacility: (state, action: PayloadAction<HealthCareFacilityModel>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    errorFetchingHealthFacility: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.data = undefined;
    },
    resetHealthFacility: (state) => {
      state.data = undefined;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchingSingleHealthFacilityDetails,
  setHealthFacility,
  errorFetchingHealthFacility,
  resetHealthFacility,
} = singleHealthFacilityDetailsSlice.actions;

export const fetchSingleHealthFacilityDetailsFromFirebase =
  (facilityId: string) => async (dispatch: AuthAppDispatch) => {
    dispatch(fetchingSingleHealthFacilityDetails());
    try {
      const doc = await FirestoreService.getDocument<HealthCareFacilityModel>(
        FirestoreDocumentReference.healthFacility(facilityId),
      );
      dispatch(setHealthFacility(doc));
    } catch (error) {
      dispatch(errorFetchingHealthFacility((error as Error).message));
    }
  };

export default singleHealthFacilityDetailsSlice.reducer;
